<ng-container *rxLet="playerState$ as playerState" class="video-player-container">
  @if (playerState.videoUrl) {
    @if (isPlayerReady(playerState)) {
      <iframe
        [attr.data-test-id]="'video-player-iframe-' + playerId"
        [attr.frameborder]="0"
        [attr.height]="playerState.config?.containerHeight"
        [attr.width]="'100%'"
        [ngClass]="{ hidden: playerState.loading }"
        [src]="playerState.embeddedHeaderVideoUrl | trustedUrl"
        (load)="iframeLoaded()"
        allow="autoplay"
        allowfullscreen
        id="{{ playerId }}"
        mozallowfullscreen
        webkitallowfullscreen
      ></iframe>
    }

    <div [ngClass]="{ hidden: !playerState.loading }" class="loader-container">
      <div
        [attr.data-test-id]="'video-player-loader-' + playerId"
        class="flex flex-center-center self-center w-full h-full"
      >
        <loader color="primary"></loader>
      </div>
    </div>
  } @else {
    <div
      [attr.data-test-id]="'video-player-error-' + playerId"
      class="broken-player flex flex-col flex-center-center gap-18 w-full h-full"
    >
      <no-data icon="broken_image" message="There was a problem with loading the video!"></no-data>
    </div>
  }
</ng-container>
